<template>
  <div class="app-title-wrap">
    <div class="app-title title_underline">
      <button v-if="rootStore.headerTitle.backBtnVisible" class="button btn-back" @click="clickBack">
          <img src="@/assets/images/ico_back.svg" alt="이전페이지" />
      </button>
      <h1 class="tit">{{ rootStore.headerTitle.centerText }}</h1>
      <button class="button btn-home" @click="goStore()">
          <img src="@/assets/images/ico_home2.svg" alt="홈" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
//import { backFunc } from '@/composables/useHeaderTitle';

const rootStore = useRootStore();
const emit = defineEmits(['clickBack']);

const clickBack = () => {
  backFunc(emit);
};

const goStore = () => {
  navigateTo('/main');
};
</script>

<style scoped>
    /* app bar */
    .app-title-wrap{
        position: relative;
        padding: 6rem;
    }
    .app-title{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        display:flex;
        align-items:center; 
        justify-content: center;
        min-height:12rem; 
        background-color: #fff;
        z-index: 10;
    }
    .app-title .tit{
        width:100%; 
        margin-bottom:0; 
        font-size:var(--hecto-font-40); 
        /* font-weight:700; */
        text-align:center; 
        line-height: 1.45;
    }
    .app-title-desc{
        margin-top:1rem;
        margin-bottom:0;
        font-size:var(--hecto-font-26);
        text-align:center;
        color:var(--hecto-black-600);
    }
    .app-title .button{
        position:absolute; 
        top:50%;
        width:6rem; 
        height:6rem;
        padding:0;
        border-radius:0;
        transform:translateY(-50%);
        opacity:0.62;
    }
    .app-title .button img{
        width:100%;
    }
    .app-title .btn-back{
        left:2.4rem;
    }
    .app-title .btn-home{
        right:2.4rem;
        opacity: 1;
    }
    .app-title .btn-home img,
    .app-title .btn-cart img{
        width: 100%;
        height: 100%;
    }
    .pc-layout .app-title{
        width:100%;
        max-width:var(--break-point-pc);
        margin:0 auto;
    }
</style>